<template>
  <CModal
      :show.sync="mediaEditModal"
      :centered="true"
      title="ویرایش محتوای آموزشی"
      size="md"
  >
    <CForm class="add-homework-modal text-right">
      <CInput v-model="formEdit.title" label="عنوان" class="text-sm mt-3" />
      <CTextarea v-model="formEdit.text" label="توضیحات" class="text-sm" />
      <div class="text-sm mb-2">فایل ها</div>
      <div
          v-for="(file, index) in formEdit.files"
          :key="index"
          class="download-file mb-3 ml-2"
      >
        <a :href="file" target="_blank" >
          <CIcon name="cil-file" />
        </a>
      </div>
    </CForm>

    <template #footer>
      <CButton
          :disabled="loading"
          @click="onEditMedia"
          color="primary"
          class="px-5"
      >
        تایید
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadFile from "../../UploadFile/UploadFile.vue";
export default {
  components: { UploadFile },
  props: {
    value: {
      type: Boolean,
    },
    media: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formEdit: {},
      loading: false,
    };
  },
  computed: {
    mediaEditModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  mounted() {
    this.formEdit = {...this.media}
  },

  methods: {
    async onEditMedia() {
      try {
        this.loading = true;
        const payload = {
          ...this.formEdit
        }
       await axios.put(`/media/${this.media.id}`, payload);
        this.mediaEditModal = false
        this.$emit("get-media");
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadFile(file) {
      this.form.files = file;
    },
  },
};
</script>

<style lang="scss" scoped>
.download-file {
  display: inline-block;
  width: 65px;
  height: 65px;
  border: 1px solid #9da5b1;
  color: #9da5b1;
  text-align: center;
  line-height: 65px;
  cursor: pointer;

  border-radius: 8px;
  .c-icon {
    width: 2rem;
    height: 2rem;
  }
}
</style>
